import TopBanner from "../../components/TopBanner/TopBanner";
import LandingNavbar from "../../components/LandingNavbar/LandingNavbar";
import Hero from "../../components/Hero/Hero";
import ProblemSection from "../../components/ProblemSection/ProblemSection";
import PlatformCapabilities from "../../components/PlatformCapabilities/PlatformCapabilities";
import CampaignTypes from "../../components/CampaignTypes/CampaignTypes";
import FAQ from "../../components/FAQ/FAQ"
import Waitlist from "../../components/Waitlist/Waitlist"
import Footer from "../../components/Footer/Footer"


const LandingPage = () => {
  return (
    <>
      <TopBanner />
      <LandingNavbar />

      <main>
        <Hero />
        <ProblemSection />
        <PlatformCapabilities/>
        <CampaignTypes />
        <FAQ />
        <Waitlist
        eyebrow="JOIN THE WAITLIST TODAY"
        title="Make every campaign count"
        description="Join the brands using Xyncely to run smarter, faster, and more accountable influencer campaigns."
        buttonText="Join the Waitlist"
        showProgress={true}
      />
        <Footer />
      </main>
    </>
  );
};

export default LandingPage;